import { onCLS, onINP, onLCP, type Metric } from 'web-vitals';
import AnalyticsManager from './AnalyticsManager';

// Report Core Web Vitals to GA4. Values are rounded to integers as GA4
// recommends (CLS is multiplied by 1000 to keep precision).
function reportMetric(metric: Metric): void {
  AnalyticsManager.getInstance().trackEvent('web_vitals', {
    metric_name: metric.name,
    metric_id: metric.id,
    metric_value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
    metric_rating: metric.rating,
    page_path: window.location.pathname,
    event_category: 'performance',
  });
}

export function initWebVitals(): void {
  onCLS(reportMetric);
  onINP(reportMetric);
  onLCP(reportMetric);
}
